<script>
  import { getContext } from 'svelte';
  import { fade, fly } from 'svelte/transition';
  import { format } from 'svelte-i18n';
  import { Button } from '@sveltestrap/sveltestrap';

  const { context } = getContext('config');

  /**
   * Translation key for the notification message.
   * @type {string}
   */
  export let message = 'label.NEW_ACTIVITY_AVAILABLE';

  /**
   * Controls visibility of the notification banner.
   * @type {boolean}
   */
  export let show = false;

  /**
   * Controls when to apply the explode css effect to the notification.
   * @type {boolean}
   */
  let exploded = false;

  /**
   * Forces a hard reload of the page after a brief animation.
   */
  const reloadPage = () => {
    exploded = true;
    setTimeout(() => location.reload(true), 200);
  };
</script>

{#if show && !context?.source}
  <div class="notification" class:exploded transition:fly={{ y: 20, x: -10, opacity: 0, duration: 300 }}>
    {$format(message)}
    <Button color="primary" size="sm" on:click={reloadPage}>{$format('label.RELOAD')}</Button>
  </div>
{/if}

<style lang="scss" src="./reload-notice.scss"></style>
